import Card from "shared/ui/card";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import StatusGif from "../../../../entities/status-gif";
import { twMerge } from "tailwind-merge";
import SuggestedProductsGrid from "widgets/checkout/suggested-products-grid";

const CheckoutEmptyCart = () => {
  return (
    <Card
      className={twMerge(
        "gg-border-t gg-border-b  gg-justify-center gg-py-14 gg-grid md:gg-justify-items-center gg-px-2"
      )}
      shadow={false}
    >
      <div className="gg-max-w-3xl gg-mb-20">
        <StatusGif
          src={"https://media0.giphy.com/media/23L8onxBh247xGq0wZ/giphy.gif"}
          alt={"Een GewoonGers Gif. Een lege winkelmand."}
        />

        <Heading headingLevel="h1" className="gg-mb-5">
          Oeps, je winkelwagen is leeg.
        </Heading>
        <Text className="gg-text-xl md:gg-text-2xl gg-mb-5">
          Voeg een product toe via de webshop!
        </Text>
        <Text className="gg-text-lg">
          Je hebt nog geen gerse producten toegevoegd aan je winkelwagen. Kies
          je voor een enkele deur of juist voor een glaswand met openslaande
          deuren? Bekijk het aanbod in onze{" "}
          <button
            className="gg-underline gg-font-bold gg-text-dark-blue gg-cursor-pointer hover:gg-text-slate-500"
            onClick={() => window.open("/producten", "_blank")}
          >
            webshop
          </button>{" "}
          of kom de producten in het echt bekijken in één van onze{" "}
          <button
            className="gg-underline gg-font-bold gg-text-dark-blue gg-cursor-pointer hover:gg-text-slate-500"
            onClick={() => window.open("/showrooms", "_blank")}
          >
            showrooms
          </button>
          .
        </Text>
      </div>

      <SuggestedProductsGrid />
    </Card>
  );
};
export default CheckoutEmptyCart;
